export type CancellationVehicleState = {
  vehicleId: string;
  registrationPlate: string;
  fleetioStatusId: string;
  fleetioStatusName: string;
  endingKms: string;
  cancellationDate: string;
  hub: string;
};

export type CancellationVehicleAction =
  | { type: "SET_VEHICLE_ID"; payload: string }
  | { type: "SET_REGISTRATION_PLATE"; payload: string }
  | { type: "SET_FLEETIO_STATUS_ID"; payload: string }
  | { type: "SET_FLEETIO_STATUS_NAME"; payload: string }
  | { type: "SET_ENDING_KMS"; payload: string }
  | { type: "SET_CANCELLATION_DATE"; payload: string }
  | { type: "SET_HUB"; payload: string };

export const cancellationVehicleInitialState: CancellationVehicleState = {
  vehicleId: "",
  registrationPlate: "",
  fleetioStatusId: "",
  fleetioStatusName: "",
  endingKms: "",
  cancellationDate: "",
  hub: "",
};

export function cancellationVehicleReducer(state: CancellationVehicleState, action: CancellationVehicleAction): CancellationVehicleState {
  switch (action.type) {
    case "SET_VEHICLE_ID":
      return { ...state, vehicleId: action.payload };
    case "SET_REGISTRATION_PLATE":
      return { ...state, registrationPlate: action.payload };
    case "SET_FLEETIO_STATUS_ID":
      return { ...state, fleetioStatusId: action.payload };
    case "SET_FLEETIO_STATUS_NAME":
      return { ...state, fleetioStatusName: action.payload };
    case "SET_ENDING_KMS":
      return { ...state, endingKms: action.payload };
    case "SET_CANCELLATION_DATE":
      return { ...state, cancellationDate: action.payload };
    case "SET_HUB":
      return { ...state, hub: action.payload };
    default:
      console.log(`Error - incorrect action sent ${action} ${state}`)
      return state;
  }
}